module.exports = __webpack_public_path__ + "img/6A.4b98516c.png";